import McpConfigList from './McpTab/McpConfigList';

function McpTab() {
    return (
        <div className="flex flex-col gap-6">
            <div className="w-full">
                <McpConfigList />
            </div>
        </div>
    );
}

export default McpTab;
